import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const noticeTypeList = createAsyncThunk('noticeType/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `notice_type`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const noticeTypeDetails = createAsyncThunk('noticeType/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `notice_type/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addNoticeType = createAsyncThunk('noticeType/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'notice_type',
            data: {
                notice_type_name: data?.values?.name,
                notice_type_priority: Number(data?.values?.priority),
                template_subject: data?.values?.template_subject,
                template_body: data?.values?.template_body,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateNoticeType = createAsyncThunk('noticeType/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'notice_type',
            data: {
                notice_type_id: data?.values?.id,
                notice_type_name: data?.values?.name,
                notice_type_priority: Number(data?.values?.priority),
                template_subject: data?.values?.template_subject,
                template_body: data?.values?.template_body,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const extractNoticeTypeRecord = (payload) => {
    if (payload?.status !== 200) return null
    const api = payload?.data
    if (!api) return null
    if (api?.data && typeof api.data === 'object' && !Array.isArray(api.data)) {
        return api.data
    }
    if (api?.notice_type_name != null || api?.id != null) {
        return api
    }
    return null
}

const extractNoticeTypeList = (payload) => {
    const body = payload?.data
    if (Array.isArray(body?.data)) return body.data
    if (Array.isArray(body)) return body
    return []
}

export const delNoticeType = createAsyncThunk('noticeType/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `notice_type/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const noticeType = createSlice({
    name: 'noticeType',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(noticeTypeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = extractNoticeTypeList(action.payload);
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(noticeTypeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = extractNoticeTypeRecord(action.payload)
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default noticeType.reducer;
